import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from "@mui/material/Alert";
import ServerSideTable from "../../../common components/serverSideTable";
import { Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TasksServices from "./services";
import MoreMenu from "./moreMenu";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const Index = () => {
  const token = localStorage.getItem("token");
  const decodeToken = jwtDecode(token);
  const supervisorId = decodeToken?.id;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [count, setCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalItems, setTotalItems] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [isAssigned, setIsAssigned] = useState("false");
  const [taskType, setTaskType] = useState(true);
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const [errors, setErrors] = useState({
    name: "",
    description: "",
    startDate: "",
    dueDate: "",
    priority: "",
  });
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    startDate: "",
    dueDate: "",
    priority: "",
  });

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [priority, setPriority] = useState("");
  const [workStatus, setWorkStatus] = useState("");

  const columns = [
    {
      field: "taskId",
      headerName: t("Task ID"),
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: t("Task Name"),
      width: 300,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "etaskStatus",
      headerName: t("Status"),
      width: 140,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{
            backgroundColor:
              params.value === "COMPLETED"
                ? "#008000"
                : params.value === "IN_PROGRESS" || params.value === "PENDING"
                ? "#AFAFAF"
                : "#E5B304",
            width: "100px",
            fontSize: "12px",
          }}
          size="medium"
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: "employeeId",
      headerName: t("Worker ID"),
      width: 150,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "dueDate",
      headerName: t("Due Date"),
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "priority",
      headerName: t("Priority"),
      width: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{
            backgroundColor:
              params.value === "High"
                ? "#FF0000"
                : params.value === "Low"
                ? "#0ACF83"
                : "#E5B304",
            width: "100px",
            fontSize: "12px",
          }}
          size="small"
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: "view",
      width: 150,
      headerName: t("Action"),
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (param) => {
        return (
          <>
            {param && param.row && (
              <MoreMenu
                data={param.row}
                taskId={param.taskId}
                stateProp={taskType}
                load={getAllTasks}
                onActionComplete={handleActionComplete}
              />
            )}
          </>
        );
      },
    },
  ];

  function getCompanies(e) {
    debugger;
    setLoading(true);
    if (e !== undefined) {
      console.log("getUsers", e, page, pageSize);
      //   console.log("getUsers", page, pageSize)
      setPage(e.page == undefined ? 0 : e.page);
      // setPage((prevData) => {
      //   if (prevData !== e.page) {
      //     return e.page == undefined ? 0 : e.page
      //   }

      // });
      setPageSize(e.pageSize == undefined ? 10 : e.pageSize);
    }
  }

  // Filter the columns based on the condition
  const filteredColumns =
    isAssigned === "true"
      ? columns
      : columns.filter((column) => column.field !== "employeeId");

  const setValues = (field, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));

    setFormData({
      ...formData,
      [field]: value,
    });
  };

  // Set the message and severity for the SnackBar
  const handleActionComplete = (message, severity) => {
    console.log("action_Message", message);
    setMessage(message);
    setSeverity(severity);
    setOpen(true);
  };

  const [timeZone, setTimeZone] = useState("");

  useEffect(() => {
    // Fetch the time zone
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimeZone(tz);
  }, []);

  useEffect(() => {
    // Fetch dashboard data when timeZone is available
    if (timeZone) {
      getAllTasks();
    }
  }, [timeZone]); // This effect runs when timeZone changes

  //get all tasks
  const getAllTasks = async () => {
    debugger;
    try {
      setLoading(true);
      const response = await TasksServices?.getTasksList(
        supervisorId,
        isAssigned,
        priority,
        workStatus,
        timeZone,
        page,
        pageSize
      );
      console.log("pagination_pageNumber", page);
      const { currentPage, totalPages, content, totalElements } =
        response.data.data;
      setCount(totalPages);
      setTotalItems(totalElements);
      setPageNumber(currentPage);
      setData(content);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401 || status === 400) {
          setMessage(data.message);
        } else {
          setMessage("An error occurred while logging in");
        }
      }
      setSeverity("error");
      setOpen(true);
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    // Setting the task type based on isAssigned
    if (isAssigned === "true") {
      setTaskType(false);
    } else {
      setTaskType(true);
    }
    if (page !== undefined) {
      if (timeZone) {
        getAllTasks();
      }
    }
  }, [page, pageSize, isAssigned]);

  //------------- Create new task--------------
  // const handleSubmit = (event) => {
  //   const form = event.currentTarget;
  //   if (form.checkValidity() === false) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   }
  //   handleCreateTask();
  //   setValidated(false);
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    let isValid = true;

    // Add custom validation for name and description fields
    if (!formData.name || formData.name.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: "Name cannot be empty",
      }));
      isValid = false;
    } else {
      setErrors((prevErrors) => {
        const { name, ...rest } = prevErrors;
        return rest;
      });
    }

    if (!formData.description || formData.description.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        description: "Description cannot be empty",
      }));
      isValid = false;
    } else {
      setErrors((prevErrors) => {
        const { description, ...rest } = prevErrors;
        return rest;
      });
    }

    if (isValid) {
      handleCreateTask();
    }

    setValidated(true);
  };

  ///Handle task create
  const handleCreateTask = () => {
    const newTaskData = {
      name: formData.name,
      description: formData.description,
      startDate: formData.startDate,
      dueDate: formData.dueDate,
      priority: formData.priority,
      assigned: true,
    };
    setLoad(true);
    TasksServices.postTaskCreate(newTaskData)
      .then((response) => {
        if (response.status === 200) {
          const data = response.data;
          setMessage(data.message);
          console.log("data_message", data.message);
          setSeverity("success");
          setOpen(true);
          setShow(false);
          setErrors({});
          setFormData({});
          getAllTasks();
          setLoad(false);
        } else if (response.status === 400) {
          setErrors({});
          setOpen(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          setMessage(error.response.data.message);
          setSeverity("error");
          setOpen(true);
        } else if (error.response && error.response.status === 400) {
          const errorResponse = error.response.data;
          if (errorResponse.errorState) {
            // Clear any previous errors
            setErrors({});
            console.log(
              "errorResponse_errorState :- " + errorResponse.errorState
            );

            // Handle error messages from the server for each field
            Object.keys(errorResponse.errorState).forEach((key) => {
              const errorMessage = errorResponse.errorState[key][0];
              setErrors((prevErrors) => ({
                ...prevErrors,
                [key]: errorMessage,
              }));
            });
          } else {
            setMessage(errorResponse.message);
            setSeverity("error");
            setOpen(true);
            // Clear any previous errors
            setErrors({});
          }
        }
      })
      .finally(() => {
        // Re-enable the button after API call is complete
        setLoad(false);
        setLoading(false);
      });
  };

  //modal calls
  const handleShowModal = () => {
    setShow(true);
    setFormData({});
    setErrors({});
  };

  //close modal popup and snackmessage when  user click on closebutton

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
    setOpen(false);
    setValidated(false);
  };

  const onChangePriority = (e) => {
    const priority = e.target.value;
    setPriority(priority);
  };

  const onChangeWorkStatus = (e) => {
    const workStatus = e.target.value;
    setWorkStatus(workStatus);
  };

  const handleSearch = () => {
    getAllTasks();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="card radius-10 p-4 px-3">
        <div className="card-header bg-transparent border-0">
          <div className="row g-3 align-items-center">
            <div className="col-12 col-md-3 col-sm-4 col-lg-3 ">
              <h5 className="mb-0">{t("Active_Tasks")}</h5>
            </div>

            <div className="col-12 col-md-9 col-sm-8 col-lg-9">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Form.Select
                  style={{ width: "150px" }}
                  className="outline-secondary"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setIsAssigned(e.target.value);
                    setPage(0);
                    // setPageSize(10);
                  }}
                >
                  <option value="false">{t("Unassigned")}</option>
                  <option value="true">{t("Assigned")}</option>
                </Form.Select>

                <button
                  className="btn btn-outlineStyled-secondary btn-blue font-14 ms-2"
                  onClick={handleShowModal}
                  type="button"
                >
                  {t("Add")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="row row-cols-1 row-cols-lg-2 g-3 align-items-center"
          style={{ marginLeft: "10px" }}
        >
          <div className="col-12 col-lg-3 col-xl-3">
            <FormControl sx={{ m: 1, minWidth: 200 }} fullWidth size="small">
              <InputLabel id="demo-simple-select-label">
                {t("Priority")}
              </InputLabel>
              <Select
                labelId="priority-status"
                id="priority-status"
                label={t("Priority")}
                name="priority"
                value={priority}
                onChange={onChangePriority}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value={`High`}>High</MenuItem>
                <MenuItem value={`Medium`}>Medium</MenuItem>
                <MenuItem value={`Low`}>Low</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-12 col-lg-3 col-xl-3">
            <FormControl sx={{ m: 1, minWidth: 200 }} fullWidth size="small">
              <InputLabel id="demo-simple-select-label">
                {t("Status")}
              </InputLabel>
              <Select
                labelId="work-status"
                id="work-status"
                label={t("Status")}
                name="workStatus"
                value={workStatus}
                onChange={onChangeWorkStatus}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value={`Pending`}>{t("Pending")}</MenuItem>
                <MenuItem value={`Working`}>{t("Working")}</MenuItem>
                <MenuItem value={`Completed`}>{t("Completed")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-12 col-lg-3 col-xl-3">
            <Button variant="contained" color="primary" onClick={handleSearch}>
              {t("Search")}
            </Button>
          </div>
        </div>
        <div className="card-body">
          {count > 0 ? (
            <ServerSideTable
              pageSize={10}
              page={0}
              count={count}
              functionName={getCompanies}
              data={data}
              loading={loading}
              columns={filteredColumns}
              idname="taskId"
            />
          ) : (
            // <p>No Task Found</p>
            <ServerSideTable
              pageSize={10}
              page={0}
              count={count}
              functionName={getCompanies}
              data={data}
              loading={loading}
              columns={filteredColumns}
              idname="taskId"
            />
          )}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header
          className="text-center border-0"
          closeButton
        ></Modal.Header>
        <Modal.Title className="text-center">
          {t("Create New Task")}
        </Modal.Title>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <Form.Group className="mb-3" controlId="formTaskName">
              <Form.Label>{t("Task Name")}</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder={t("Enter task name")}
                name="name"
                value={formData.name}
                onChange={(e) => setValues("name", e.target.value)}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formTaskDescription">
              <Form.Label>{t("Description")}</Form.Label>
              <Form.Control
                required
                as="textarea"
                rows={4}
                placeholder={t("Enter Description...")}
                name="description"
                value={formData.description}
                onChange={(e) => setValues("description", e.target.value)}
                isInvalid={!!errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formStartDate">
              <Form.Label>{t("Start Date")}</Form.Label>
              <Form.Control
                required
                type="date"
                placeholder="Start Date"
                name="startDate"
                value={formData.startDate}
                onChange={(e) => setValues("startDate", e.target.value)}
                min={new Date().toISOString().split("T")[0]}
                isInvalid={!!errors.startDate}
              />
              <Form.Control.Feedback type="invalid">
                {errors.startDate}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDueDate">
              <Form.Label>{t("Due Date")}</Form.Label>
              <Form.Control
                required
                error
                type="date"
                placeholder="Due Date"
                name="dueDate"
                value={formData.dueDate}
                onChange={(e) => setValues("dueDate", e.target.value)}
                min={new Date().toISOString().split("T")[0]}
                isInvalid={!!errors.dueDate}
              />
              <Form.Control.Feedback type="invalid">
                {errors.dueDate}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPriority">
              <Form.Label>{t("Select Priority")}</Form.Label>
              <Form.Select
                required
                name="priority"
                value={formData.priority}
                onChange={(e) => setValues("priority", e.target.value)}
                isInvalid={!!errors.priority}
              >
                <option value="">{t("Select Priority")}</option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.priority}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
          <div className="text-center w-75 mx-auto mt-5 mb-4">
            {load ? (
              <CircularProgress />
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                className="w-100"
                disabled={load} // Disable the button when loading is true
              >
                {t("Create Task")}
              </Button>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={open}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleClose}
        >
          <MuiAlert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </MuiAlert>
        </Snackbar>
      </Stack>
    </>
  );
};

export default Index;
